export const DEFAULT_FREE_SHIPPING_CARD = {
  enabled: true,
  title: 'Free Shipping',
  homeDescription: 'For orders from $50',
  color: '#4CAF50'
};

export const normalizeFreeShippingCard = (settings = {}) => ({
  ...DEFAULT_FREE_SHIPPING_CARD,
  ...settings,
  enabled: settings.enabled !== false,
  title: settings.title ?? DEFAULT_FREE_SHIPPING_CARD.title,
  homeDescription: settings.homeDescription ?? DEFAULT_FREE_SHIPPING_CARD.homeDescription,
  color: settings.color || DEFAULT_FREE_SHIPPING_CARD.color
});
